// Generated by scripts/build-ui-icons.mjs.
export { SmileyWink as default } from "../ui/glyphs-7";
